<template>
  <div class="content-container">
    <div class="flex-col">
      <span class="mb-small flex">
        {{ "forgot_password.titles.forgot_password" | translate }}
      </span>
      <input
        type="text"
        name="email"
        v-model="input.email"
        :placeholder="'register.form.email' | translate"
        class="form-input"
      />
      <br />
      <button
        class="button salmon"
        type="button"
        :disabled="!form_valid"
        v-on:click="sendResetMail"
      >
        {{ "forgot_password.form.send_link" | translate }}
      </button>
    </div>
  </div>
</template>

<script>
import { forgotPassword } from "../services/api";
const field_validations = {
  email: email => !!email
};
export default {
  name: "Register",
  data() {
    return {
      input: {
        email: null
      }
    };
  },
  computed: {
    form_valid() {
      return Object.keys(this.input).every(key =>
        field_validations[key](this.input[key])
      );
    }
  },
  methods: {
    async sendResetMail(event) {
      event && event.preventDefault();
      const { email } = this.input;
      {
        const reset_route = "http://localhost:8080/reset_password";
        const res = await forgotPassword(email, reset_route);
        if (!(res instanceof Error)) {
          this.$bvToast.toast("Reset mail sent", {
            title: "Success",
            autoHideDelay: 5000,
            variant: "success"
          });
          this.$router.push({ name: "Login" });
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.flex-col {
  max-width: 20rem;
  margin: auto;
  margin-top: 5rem;
}
</style>
